import PhoneSvg from '@assets/images/svg/phone.svg';
import React from 'react';
import { View } from 'react-native';

export interface PhoneIconProps {
  size?: number;
  width?: number;
  height?: number;
  color?: string;
  strokeWidth?: number;
}

export function PhoneIcon({ size, width, height, color = '#333333', strokeWidth = 2 }: PhoneIconProps) {
  // If width/height are provided, use them; otherwise use size for both
  const iconWidth = width ?? size ?? 24;
  const iconHeight = height ?? size ?? 24;
  
  return (
    <View style={{ width: iconWidth, height: iconHeight, justifyContent: 'center', alignItems: 'center' }}>
      <PhoneSvg width={iconWidth} height={iconHeight} color={color} strokeWidth={strokeWidth} />
    </View>
  );
}

export default PhoneIcon;